import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';

import Profile from './Tabs/Profile';
import SendPhoneNumber from './Tabs/SendPhoneNumber';
import Verification from './Tabs/Verification';

import './Login.css';

const Login = () => {
  const history = useHistory();
  const [page, setPage] = useState('phone');
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [error, setError] = useState(false);
  const [isSendPhoneLoading, setIsSendPhoneLoading] = useState(false);
  const [isSendCodeLoading, setIsSendCodeLoading] = useState(false);
  const [isResendCodeLoading, setIsResendCodeLoading] = useState(false);
  const recaptchaVerifier = useRef(null);
  const confirmationResult = useRef(null);
  const auth = getAuth();
  const user = auth.currentUser;

  const onSignInSubmit = async (e) => {
    e.preventDefault();
    setIsSendPhoneLoading(true);
    recaptchaVerifier.current = new RecaptchaVerifier(
      'sign-in-button',
      {
        size: 'invisible',
      },
      auth,
    );
    const appVerifier = recaptchaVerifier.current;

    try {
      confirmationResult.current = await signInWithPhoneNumber(auth, phone, appVerifier);
      setPage('verification');
    } catch (error) {
      setError(true);
      console.log('Error with OTP', error);
    }
    setIsSendPhoneLoading(false);
  };

  const resendCode = async () => {
    setIsResendCodeLoading(true);
    try {
      confirmationResult.current = await signInWithPhoneNumber(
        auth,
        phone,
        recaptchaVerifier.current,
      );
    } catch (error) {
      setError(true);
      console.log('Error with OTP', error);
    }
    setIsResendCodeLoading(false);
  };

  const confirmOTP = async (e) => {
    e.preventDefault();
    setIsSendCodeLoading(true);
    try {
      await confirmationResult.current?.confirm(otp);
      if (!user) {
        setPage('profile');
      } else if (user) {
        history.push('/rooms');
      }
    } catch (error) {
      console.log('OTP failed', error);
      setError(true);
    }
    setIsSendCodeLoading(false);
  };

  const reRenderButton = () => <b id="sign-in-button" />;
  return (
    <div className="login">
      {error ? reRenderButton() : <div id="sign-in-button" />}
      {page === 'phone' && (
        <SendPhoneNumber
          error={error}
          setPhone={setPhone}
          setError={setError}
          isLoading={isSendPhoneLoading}
          onSignInSubmit={onSignInSubmit}
        />
      )}
      {page === 'verification' && (
        <Verification
          error={error}
          setError={setError}
          confirmOTP={confirmOTP}
          phone={phone}
          setOtp={setOtp}
          setPage={setPage}
          isLoading={isSendCodeLoading}
          resendCode={resendCode}
          isResendCodeLoading={isResendCodeLoading}
          otp={otp}
        />
      )}
      {page === 'profile' && <Profile setPage={setPage} />}
    </div>
  );
};

export default Login;
